import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { ExpertReceipt } from '../models/expert-receipt.schema';

@Injectable({
  providedIn: 'root'
})
export class ExpertReceiptsService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/expert-receipts`;
 
  async getAllExpertReceipts(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<ExpertReceipt[]> {
    return this.getAll(page, limit, order, filter);
  }

  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<ExpertReceipt[]>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async approveReceipt(id: number): Promise<ExpertReceipt> {
    return this.request(() => this.http.put(`${this.url}/approve/${id}`, {} ).toPromise() );
  }

  async paidReceipt(id: number): Promise<ExpertReceipt> {
    return this.request(() => this.http.put(`${this.url}/paid/${id}`, {} ).toPromise() );
  }

  async uploadReceipt(id: number, formData: any): Promise<ExpertReceipt> {
    return this.request(() =>
      this.http.put<ExpertReceipt>(`${this.url}/upload/${id}`, formData).toPromise()
    );
  }

  /*
  async createExpertReceipt(formValues: any): Promise<ExpertReceipt>{
    return this.request(() => this.http.post(`${this.url}`, formValues ).toPromise() );
  }

  async updateExpertReceipt(id: number, formValues: any): Promise<ExpertReceipt>{
    return this.request(() => this.http.put(`${this.url}/${id}`, formValues ).toPromise() );
  }

  async getExpertReceipt(id: number): Promise<ExpertReceipt>{
    return this.request(() => this.http.get(`${this.url}/${id}` ).toPromise() );
  }

  async deleteExpertReceipt(id: number): Promise<ExpertReceipt>{
    return this.request(() => this.http.delete(`${this.url}/${id}` ).toPromise() );
  }
  */
}
